module.exports = __webpack_public_path__ + "static/img/pinch_zoom.6432aa2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pinch_zoom.gif
// module id = C1gG
// module chunks = 6